import { render, staticRenderFns } from "./OrgSettings.vue?vue&type=template&id=47064a35&scoped=true"
import script from "./OrgSettings.vue?vue&type=script&lang=js"
export * from "./OrgSettings.vue?vue&type=script&lang=js"
import style0 from "./OrgSettings.vue?vue&type=style&index=0&id=47064a35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47064a35",
  null
  
)

export default component.exports